<template>
  <FormItem 
    :prop="prop"
    :label="label"
  >
    <Icon 
      type="key"
      size="25"
    />
    <Input
      v-model="val"
      placeholder="密碼"
      size="large"
      :type="showPassword ? 'text' : 'password'"
    >
    </Input>
    <Icon
      size="25"
      :type="showPassword ? 'eye-disabled' : 'eye'"
      @click.native="toggleShowPassword"
    />
  </FormItem>
</template>

<script>
  import { FormItem, Input, Icon } from 'iview';

  export default {
    components: { FormItem, Input, Icon },
    props: {
      prop: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        showPassword: false
      };
    },
    computed: {
      val: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    methods: {
      toggleShowPassword() {
        this.showPassword = !this.showPassword;
      }
    }
  };
</script>